export default {"src":"https://s.sylndr.com/c-9cd064a/_next/static/media/highlights-icon.04212b2f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};